import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import messages from '../../../fulfillment-planner/labeled-row/messages';
import LabeledRow from '../../../fulfillment-planner/labeled-row';
import InsuredAmountContainer from '../../../fulfillment-planner/insured-amount/container';
import { useFulfillmentPlannerContext } from '../../../fulfillment-planner/context';
import style from './style.module.less';

export const InsuredAmount = ({ fulfillmentPlanId }) => {
  const { hasInsuranceProviderSelected } = useFulfillmentPlannerContext();
  if (!hasInsuranceProviderSelected) {
    return null;
  }

  return (
    <LabeledRow label={<FormattedMessage {...messages.insureAmt} />} labelClassName={style.label}>
      <InsuredAmountContainer fulfillmentPlanId={fulfillmentPlanId} />
    </LabeledRow>
  );
};

InsuredAmount.propTypes = {
  fulfillmentPlanId: PropTypes.string.isRequired,
};
